module.exports = __webpack_public_path__ + "static/media/cs_Dividend_Payment.165ff23e.png";